<template>
  <el-upload
    action=""
    class="chat-upload"
    :show-file-list="false"
    :http-request="sendImg"
    :before-upload="beforeUpload"
  >
    <i class="chat iconfont iconfile"></i>
  </el-upload>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      image: null
    }
  },

  computed: {
    ...mapState(['receivingUser'])
  },

  methods: {
    ...mapActions(['sendFileMessage']),

    beforeUpload(file) {
      var isLt = file.size / 1024 < 1024 * 10

      if (!isLt) {
        this.$message.error('上传大小不能超过 10M!')
      }
      return isLt
    },

    sendImg(req) {
      let fileObj = {
        data: req.file,
        filename: req.file.name,
        filetype: req.file.type,
        url: window.URL.createObjectURL(req.file)
      }
      let obj = {
        chatType: 'singleChat',
        chatId: this.receivingUser,
        file: fileObj,
        roomType: false
      }
      this.sendFileMessage(obj)
    }
  }
}
</script>
<style scoped>
.chat-upload .chat.iconfont {
  margin-right: 10px;
  font-size: 25px;
}
</style>
